import React from 'react';
import { Award, Shield, Users, TrendingUp } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { getImageUrl } from '../lib/imageUtils';

const About = ({ data = {} }) => {
  const aboutImage = getImageUrl(data.about_image_url, 'https://images.unsplash.com/photo-1646009445351-b8192e095f3a?w=800');
  const stats = [
    { icon: Award, label: data.stat_1_label || 'Authorized Distributor', value: data.stat_1_value || 'Astral & Zoloto', color: 'from-blue-500 to-blue-600' },
    { icon: Users, label: data.stat_2_label || 'Happy Clients', value: data.stat_2_value || '1000+', color: 'from-yellow-500 to-yellow-600' },
    { icon: Shield, label: data.stat_3_label || 'Quality Assured', value: data.stat_3_value || '100%', color: 'from-blue-600 to-blue-700' },
    { icon: TrendingUp, label: data.stat_4_label || 'Years in Business', value: data.stat_4_value || '15+', color: 'from-yellow-600 to-yellow-700' },
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-sm font-semibold text-blue-600 uppercase tracking-wider mb-3">{data.section_subtitle || 'About Us'}</h2>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {data.section_title_part1 || 'Your Trusted'} <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-800">{data.section_title_part2 || 'Piping Partner'}</span>
          </h3>
          <div className="w-24 h-1 bg-gradient-to-r from-yellow-500 to-yellow-600 mx-auto"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img 
              src={aboutImage} 
              alt="About" 
              className="rounded-2xl shadow-2xl w-full h-auto max-h-[500px] object-contain bg-gradient-to-br from-blue-50 to-yellow-50"
            />
          </div>
          <div className="space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              <span className="font-bold text-blue-900 text-2xl">{data.company_name || 'Narain Trading Co.'}</span> {data.paragraph_1 || 'has been serving the industry for over a decade.'}
            </p>
            <p className="text-gray-600 leading-relaxed">
              {data.paragraph_2 || 'As an authorized distributor of Astral Pipes and Zoloto Valves, we ensure quality products.'}
            </p>
            <p className="text-gray-600 leading-relaxed">
              {data.paragraph_3 || 'We specialize in serving contractors, MEP consultants, builders, and industrial clients.'}
            </p>
            <div className="bg-gradient-to-r from-blue-50 to-blue-100 p-6 rounded-xl border-l-4 border-blue-600">
              <p className="text-blue-900 font-semibold mb-2">{data.commitment_title || 'Our Commitment'}</p>
              <p className="text-gray-700">
                {data.commitment_text || 'We are committed to providing exceptional service and competitive pricing.'}
              </p>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <Card key={index} className="border-2 hover:border-blue-200 transition-all hover:shadow-lg group">
              <CardContent className="p-6 text-center">
                <div className={`w-16 h-16 bg-gradient-to-br ${stat.color} rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform shadow-lg`}>
                  <stat.icon className="text-white" size={32} />
                </div>
                <h4 className="text-3xl font-bold text-gray-900 mb-2">{stat.value}</h4>
                <p className="text-gray-600 font-medium">{stat.label}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
